module.exports = __webpack_public_path__ + "static/media/personByWorking.394ada63.jpg";